module.exports = __webpack_public_path__ + "static/media/einvoice-reject.7cecf326.svg";